import { render, staticRenderFns } from "./DomainInput.vue?vue&type=template&id=5b160d74&scoped=true&"
import script from "./DomainInput.vue?vue&type=script&lang=js&"
export * from "./DomainInput.vue?vue&type=script&lang=js&"
import style0 from "./DomainInput.vue?vue&type=style&index=0&id=5b160d74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b160d74",
  null
  
)

export default component.exports